<template>
  <div class="main">
    <div class="banana">
      <img src="../assets/img/banner/画板 2.png" alt />
    </div>
    <div class="center">
      <div class="nav">
        <p>
          当前位置：
          <span @click="shouye" class="navvv">首页</span> > 新闻中心
        </p>
      </div>
      <!-- <h1 class="htitle">新闻动态</h1> -->
      <ul class="newsUl">
        <li class="newsList" v-for="(item,index) in newsData" :key="index">
          <div :class="beforeLeft" @click="detial(item.newid)" v-html="item.introduce"></div>
          <div class="right">
            <h3 @click="detial(item.newid)">{{ item.title }}</h3>
            <p class="msg" v-html="item.ss"></p>
            <p class="time">{{ item.pushtime | dateformat('YYYY-MM-DD') }}</p>
          </div>
        </li>
      </ul>
      <!-- <el-pagination
        background
        layout="prev, pager, next, jumper, sizes"
        :current-page="startPage"
        :prev-text="prev"
        :next-text="next"
        :page-sizes="pagesizearrray"
        :page-size="pageSize"
        :total="totalNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />-->
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      cSearchVal: "",
      startPage: 1,
      // 每页的数据
      pageSize: 10,
      pagesizearrray: [10, 20, 30, 40],
      totalNum: 0,
      tableData: [],
      newsData: [],
      beforeLeft:'beforeLeft'
    };
  },
  mounted() {
    this.getList();
    // window.setTimeout(this.beforeLeft = 'left',10000);
  },
  methods: {
    // 请求新闻列表
    getList() {
      const _this = this;
      this.$axios
        .post("http://101.200.166.238:9006/pushnews/queryAll")
        .then((response) => {
          // console.log("111", response);
          _this.newsData = response.data;
          window.setTimeout(function(){ this.beforeLeft = 'left'; }, 3000);
          // window.setTimeout(this.beforeLeft = 'left',10000);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    shouye() {
      this.$router.replace("/");
    },
    detial(index) {
      // console.log('2222',index);
      this.$router.push({
        path: "/newsDetial",
        query: {
          newid: index,
        },
      });
    },
  },
  components: {},
};
</script>

<style scoped lang="less">
.main {
  width: 100%;
  font-size: 16px;
  .banana {
    width: 100%;
    // background: url("../assets/img/banner/画板 2.png") center no-repeat;
    // background-size: cover;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .center {
    width: 1160px;
    margin: 0 auto;
    // padding: 0px 360px;
    box-sizing: border-box;
    overflow: hidden;
    .nav {
      width: 100%;
      border-bottom: 1px solid #a0a0a0;
      opacity: 1;
      font-size: 12px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #666666;
      line-height: 36px;
    }
    .htitle {
      width: 103px;
      height: 40px;
      opacity: 1;
      font-size: 25px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #4279db;
      border-bottom: 1px solid #4279db;
      margin-top: 67px;
      margin-bottom: 60px;
    }
    .newsUl {
      margin: 0;
      padding: 0;
      margin-top: 60px;
      .newsList {
        height: 250px;
        border-bottom: 1px dashed #1f89ec;
        display: flex;
        justify-content: space-between;
        margin-bottom: 71px;
        .beforeLeft{
          width: 318px;
          height: 218px;
          overflow: hidden;
          float: left;
          img {
            width: 100% !important;
            height: 100%;
            margin: 0 auto;
            display: block;
          }
        }
        .left {
          width: 318px;
          height: 218px;
          overflow: hidden;
          float: left;
          img {
            width: 100% !important;
            height: 100%;
            margin: 0 auto;
            display: block;
          }
        }
        .msg:hover {
          cursor: pointer;
        }
        .right {
          width: 780px;
          h3 {
            opacity: 1;
            font-size: 18px;
            font-family: Microsoft YaHei Regular,
              Microsoft YaHei Regular-Regular;
            font-weight: 400;
            text-align: justifyLeft;
            color: #4279db;
            margin: 0;
          }
          h3:hover {
            cursor: pointer;
          }
          .msg {
            width: 100%;
            height: 100px;
            opacity: 1;
            font-size: 14px;
            font-family: Microsoft YaHei Regular,
              Microsoft YaHei Regular-Regular;
            font-weight: 400;
            text-align: justifyLeft;
            color: #666666;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            margin-top: 30px;
          }
          .time {
            opacity: 1;
            font-size: 14px;
            font-family: Microsoft YaHei Regular,
              Microsoft YaHei Regular-Regular;
            font-weight: 400;
            text-align: justifyLeft;
            color: #999999;
            margin-top: 30px;
          }
        }
      }
    }
  }
}
.el-pagination {
  margin-bottom: 30px !important;
}
</style>
